var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMoneyVector(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 191,
    height: 163,
    viewBox: "0 0 191 163",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.2041 36.3559C32.8739 3.72994 74.8454 -5.43252 113.708 3.64933C151.802 12.5516 186.355 39.8754 189.989 77.6694C193.361 112.725 160.098 134.497 127.611 148.215C94.4097 162.233 54.3393 172.11 27.7927 146.155C-2.26323 116.768 -7.48851 70.6783 13.2041 36.3559Z",
    fill: "url(#paint0_linear_82_308)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_82_308",
    x1: 11.7559,
    y1: 38.8336,
    x2: 170.04,
    y2: 130.219,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A8D1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7AC6BE"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoneyVector);
export default __webpack_public_path__ + "static/media/Money_Vector.f8d55297f40e911c4b7005c133cc420f.svg";
export { ForwardRef as ReactComponent };